import React, { useState } from 'react';
import { CalcCard, CalcField, ResultStat, GrowthChart, CalcFooter, formatINR, sipFutureValue, SERIES_INVESTED, SERIES_VALUE } from './shared';

export const SipCalculator = () => {
  const [monthly, setMonthly] = useState(5000);
  const [years, setYears] = useState(10);
  const [rate, setRate] = useState(12);

  const y = Math.max(1, Math.round(years));
  const data = Array.from({ length: y }, (_, i) => ({
    label: `Yr ${i + 1}`,
    invested: monthly * 12 * (i + 1),
    value: sipFutureValue(monthly, rate, 12 * (i + 1)),
  }));
  const { invested, value } = data[data.length - 1];

  return (
    <CalcCard title="SIP Calculator" subtitle="See how a fixed monthly investment may grow over time." testId="sip-calculator">
      <div className="space-y-6 mb-8">
        <CalcField label="Monthly Investment (₹)" value={monthly} onChange={setMonthly} min={500} max={200000} step={500} testId="sip-monthly" />
        <CalcField label="Investment Period (Years)" value={years} onChange={setYears} min={1} max={40} testId="sip-years" />
        <CalcField label="Assumed Annual Return (%) – illustrative" value={rate} onChange={setRate} min={1} max={20} step={0.5} testId="sip-returns" />
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 mb-6">
        <ResultStat label="Total Invested" value={formatINR(invested)} testId="sip-invested-result" />
        <ResultStat label="Illustrative Gains" value={formatINR(value - invested)} testId="sip-gains-result" accent />
        <ResultStat label="Illustrative Future Value" value={formatINR(value)} testId="sip-future-result" />
      </div>
      <GrowthChart data={data} series={[SERIES_INVESTED, SERIES_VALUE]} testId="sip-chart" />
      <CalcFooter testId="sip" />
    </CalcCard>
  );
};
